<template>
  <LayoutSection
    v-if="links?.length || isEditing"
    :id="id"
    bg-primary
    padding
    :hero-title="title"
    :lead="text"
    class="paragraph--padded"
  >
    <div class="grid gap-15 lg:gap-20 md:grid-cols-2">
      <div
        v-for="(link, i) in links"
        :key="i"
        class="bg-white rounded md:rounded-large"
      >
        <FieldItemTypeLinkDescription
          v-bind="link"
          class="link hyphens-auto with-icon p-15 h-full justify-start auto-rows-min lg:text-lg pl-10 lg:pl-[12px]"
        />
      </div>
    </div>
  </LayoutSection>
</template>

<script lang="ts" setup>
import type { ParagraphPopularLinksFragment } from '#graphql-operations'
import { slugify } from '~/helpers/slugify'

const { isEditing } = defineBlokkli({
  bundle: 'popular_links',
  globalOptions: ['showInToc', 'bkVisibleLanguages'],
  chunkName: 'rare',
  editor: {
    editTitle: (el) => el.querySelector('h2')?.innerText,
  },
})

const props = defineProps<{
  title?: ParagraphPopularLinksFragment['title']
  text?: ParagraphPopularLinksFragment['text']
  links?: ParagraphPopularLinksFragment['links']
}>()

const id = computed(() => slugify(props.title))

defineOptions({
  name: 'ParagraphPopularLinks',
})
</script>
